// Global imports
import { ContentEditor, NumberedCardGrid } from '~/components'

// Types
import type { PortableTextBlock } from '@portabletext/react'
import type { NumberedCardItem, NumberedCardMobileView } from '~/types'

interface BlockNumberedCardsProps {
  content?: PortableTextBlock[]
  cardStyle?: 'plain' | 'outlined'
  mobileLayout?: NumberedCardMobileView
  cards?: NumberedCardItem[]
}

// Main export
export default function BlockNumberedCards({
  content,
  cardStyle = 'plain',
  mobileLayout = 'stacked',
  cards,
}: BlockNumberedCardsProps) {
  if (!cards?.length) return null

  // Plain cards are meant for dark backgrounds, so their carousel dots are
  // the light set
  return (
    <div className="container">
      {content && (
        <div className="mb-8 max-w-2xl">
          <ContentEditor content={content} />
        </div>
      )}
      <NumberedCardGrid
        cards={cards}
        mobileView={mobileLayout}
        outlined={cardStyle === 'outlined'}
        onDark={cardStyle === 'plain'}
      />
    </div>
  )
}
